import {MvsCrudService} from "../../../../../../../core/shared/service/crud/mvs-crud.service";
import {Component, OnInit} from '@angular/core';
import {ConfirmationService, MenuItem} from 'primeng/api';
import {TicketTypeDto} from '../../../../../model/dto/entity/ticket-type.dto';
import {TicketTypeActionDto} from '../../../../../model/dto/entity/ticket-type-action.dto';
import {TicketTypeObjectRoleDto} from '../../../../../model/dto/entity/ticket-type-object-role.dto';
import {TicketTypeObjectTypeDto} from '../../../../../model/dto/entity/ticket-type-object-type.dto';
import {TicketTypeNotificationTypeDto} from '../../../../../model/dto/entity/ticket-type-notification-type.dto';
import {TicketTypeCompleteStatusDto} from '../../../../../model/dto/entity/ticket-type-complete-status.dto';
import {TicketTypeService} from '../../../../../service/api/ticket-type.service';
import {TicketTypeActionService} from '../../../../../service/api/ticket-type-action.service';
import {TmTicketTypeActionDto} from '../../../../../model/dto/entity/tm-ticket-type-action.dto';
import {ActivatedRoute} from '@angular/router';
import {
    ObjectBaseModeComponent
} from '../../../../../../../core/shared/object/mvs-object-base/object-base-mode.component';
import {WidgetData} from '../../../../../../../core/shared/widget/widget-data';
import {WidgetHelperButton} from '../../../../../../../core/shared/basic/widget-helper-button';
import {ObjectIdentifier} from '../../../../../../../core/shared/basic/object-identifier';
import {MvsCoreService} from '../../../../../../../core/shared/service/mvs-core.service';
import {MvsMessageService} from '../../../../../../../core/shared/service/message/mvs-message.service';
import {ObserverService} from '../../../../../../../core/shared/object/service/observer.service';
import {ObjectIdentifierData} from '../../../../../../../core/shared/basic/object-identifier-data';
import {FilterCriteria} from '../../../../../../../core/shared/filter/api/filter.criteria';
import {ObjectRequestList} from '../../../../../../../core/shared/dto/object/request/object-request-list';
import {TicketTypeActionTypeInternal} from '../../../../../enum/ticket-type-action-type-internal.enum';
import {WidgetFactory} from '../../../../../../../core/shared/widget/service/widget.factory';
import {DtoDetail} from '../../../../../../../core/shared/dto/dto.detail';
import {MvsFormControlOverwrite} from '../../../../../../../core/shared/logic/form/logic/mvs-form-control-overwrite';
import {MvsFormFieldAccessEnum} from '../../../../../../../core/shared/logic/form/logic/mvs-form-field-access.enum';
import {WidgetDataParam} from '../../../../../../../core/shared/widget/widget-data-param';
import {NavigationItem} from '../../../../../../../core/shared/dto/navigation/navigation-item';
import {
    WidgetToolbarCallbackInterface
} from '../../../../../../../core/shared/widget/widget-toolbar-callback.interface';
import {QlQueryDto} from '../../../../../../../core/shared/ql/data/dto/ql-query.dto';
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from '../../../../../../../core/shared/helper/widget-function-call-back-create';
import {Sorting} from '../../../../../../../core/shared/misc/sorting';

@Component({
    selector: 'ticket-type-object-component-base',
    template: '',
    standalone: false
})
export class TicketTypeObjectBaseComponent extends ObjectBaseModeComponent implements OnInit {

    ticketTypeCompletionStatusService: MvsCrudService;
    ticketTypeNotificationTypeService: MvsCrudService;
    ticketTypeObjectTypeService: MvsCrudService;
    ticketTypeObjectRoleService: MvsCrudService;
    sideBarMenuItems: MenuItem[];
    selectedItem: MenuItem;
    objectViewWidget: WidgetData;
    objectWidget: WidgetData;

    ticketTypeWidget: WidgetData;
    ticketTypeUpdateWidget: WidgetData;
    ticketTypeActionWidget: WidgetData;
    ticketTypeActionTicketMappingWidget: WidgetData;
    ticketTypeActionProcessMappingWidget: WidgetData;
    ticketTypeObjectRoleWidget: WidgetData;
    ticketTypeObjectTypeWidget: WidgetData;
    ticketTypeNotificationTypeWidget: WidgetData;
    ticketTypeNotificationTypeMappingWidget: WidgetData;
    ticketTypeCompletionStatusWidget: WidgetData;
    ticketTypeFieldWidget: WidgetData;

    widgetToolbarCreateButtons: WidgetHelperButton[];
    widgetToolbarUpdateButtons: WidgetHelperButton[];
    ticketTypeToolbarButton: WidgetHelperButton[];
    ticketTypeUpdateToolbarButton: WidgetHelperButton[];

    ticketTypes: TicketTypeDto[] = [];
    ticketTypeActionList: TicketTypeActionDto[];
    ticketTypeObjectRoleList: TicketTypeObjectRoleDto[];
    ticketTypeObjectTypeList: TicketTypeObjectTypeDto[];
    ticketTypeNotificationTypeList: TicketTypeNotificationTypeDto[];
    ticketTypeCompletionList: TicketTypeCompleteStatusDto[];

    ticketTypeActionInternalType: TicketTypeActionTypeInternal;
    protected readonly TicketTypeActionTypeInternal = TicketTypeActionTypeInternal;
    selectedObject: ObjectIdentifier;

    activeIndex: number;
    isTicketTypeUpdate: boolean;
    isCreateMode: boolean;
    selectedObjectType: string;

    constructor(
        protected route: ActivatedRoute,
        protected coreService: MvsCoreService,
        protected messageService: MvsMessageService,
        protected confirmationService: ConfirmationService,
        protected observerService: ObserverService,
        protected ticketTypeService: TicketTypeService,
        protected ticketTypeActionService: TicketTypeActionService) {
        super(route);
    }

    ngOnInit() {
        // initialize navigation items
        this.loadSideBarMenuItems();

        super.ngOnInit();




        this.ticketTypeNotificationTypeService = this.coreService.getCrudService("tm.TicketTypeNotificationType");
        this.ticketTypeObjectTypeService = this.coreService.getCrudService("tm.TicketTypeObjectType");
        this.ticketTypeObjectRoleService = this.coreService.getCrudService("tm.TicketTypeObjectRole");
        this.onObjectChanged();

        this.initialized = true;
    }

    /**
     * On Object Change. When object is retrieved
     */
    onObjectChanged() {

        // initialize the widget toolbar buttons
        this.initWidgetToolbarButtons();

        // initialize all widgets
        this.refreshWidgets();

        // load parent ticket types for accordion display
        if (this.dto['parentDtoId']) {
            this.loadParentTicketTypes(this.dto['parentDtoId']);
        }

    }

    /**
     * Recursively load parent ticket types for accordion display.
     */
    private loadParentTicketTypes(ticketTypeId: number): void {
        if (!ticketTypeId) return;

        this.ticketTypeService.get(ticketTypeId, null, false).subscribe((res: TicketTypeDto) => {
            this.ticketTypes.push(res);
            if (res?.parentDtoId) {
                this.loadParentTicketTypes(res.parentDtoId);
            }
        });
    }

    /**
     * load and initialize sidebar navigations
     */
    loadSideBarMenuItems() {

    }

    /**
     * initialize widget toolbar buttons
     */
    initWidgetToolbarButtons() {
        this.widgetToolbarCreateButtons = [
            {
                label: null,
                icon: 'fa-regular fa-plus text-primary',
                display: true,
                action: 'create',
                tooltip: 'Create'
            }
        ];

        this.widgetToolbarUpdateButtons = [
            {
                label: null,
                icon: 'fa-light fa-pen-to-square text-primary',
                display: true,
                action: 'update',
                tooltip: 'Edit'
            }
        ];

        this.ticketTypeToolbarButton = [
            {
                label: null,
                icon: 'fa-light fa-pen-to-square text-primary',
                display: true,
                action: 'ticketToggle',
                tooltip: 'Edit'
            }
        ];

        this.ticketTypeUpdateToolbarButton = [
            {
                label: null,
                icon: 'fa-light fa-table text-primary',
                display: true,
                action: 'ticketToggle',
                tooltip: 'Data View'
            }
        ];
    }

    /**
     * handle when an object is ticket type action is selected
     * @param object
     */
    handleTicketTypeAction(object: ObjectIdentifierData | ObjectIdentifier) {
        const data = object as ObjectIdentifierData;
        const id = data.data['e.id'];
        const oi = new ObjectIdentifier('tm.TicketTypeAction', id);
        this.ticketTypeActionTicketMappingWidget = null;
        this.ticketTypeActionProcessMappingWidget = null;

        const ticketTypeAction = <TmTicketTypeActionDto>data.data;
        this.clearWidget();
        this.ticketTypeActionInternalType = ticketTypeAction['e.internalType'];

        if (this.ticketTypeActionInternalType == TicketTypeActionTypeInternal.ticket) {
            this.refreshTicketTypeActionTicketMappingWidget(id);
        } else if (this.ticketTypeActionInternalType == TicketTypeActionTypeInternal.process) {
            this.refreshTicketTypeActionProcessMappingWidget(id);
        }
        this.handleObjectViewWidget(oi, false);

    }

    handleTicketTypeNotificationType(object: ObjectIdentifierData | ObjectIdentifier) {
        const data = object as ObjectIdentifierData;
        const id = data.data['e.id'];

        this.ticketTypeNotificationTypeMappingWidget = WidgetFactory.createWidgetTableEntityBasicQl('tm.ticket.type.notification.type.mapping.widget.basic', 'Benachrichtigung Mapping', 'tm.TicketTypeNotificationTypeMapping', [FilterCriteria.create('e.ticketTypeNotificationTypeId', FilterCriteria.cOperatorEqual, id)]);
        this.ticketTypeNotificationTypeMappingWidget.functionCallbacks = this.widgetToolbarCreate('ticketTypeNotificationTypeDtoId', id);

        const oi = new ObjectIdentifier('tm.TicketTypeNotificationType', id);
        this.handleObjectViewWidget(oi, false);
    }

    handleObjectView(object: ObjectIdentifierData | ObjectIdentifier, objectId: string, objectType: string) {
        const event = object as ObjectIdentifierData;
        const id = event.data[objectId];
        const oi = new ObjectIdentifier(objectType, id);
        this.handleObjectViewWidget(oi);
    }
    /**
     * handle whether to show data widget or object widget
     * @param object
     * @param createMode
     * @param updateMode
     */
    handleObjectViewWidget(object: ObjectIdentifier, createMode: boolean = false, updateMode: boolean = false) {
        this.clearWidget();
        this.selectedObject = object;

        if (createMode) {
            this.isCreateMode = true;
        }

        this.objectViewWidget = WidgetFactory.createWidgetEntityData(
            `${object.objectType}.object.view.widget`,
            'Konfiguration',
            object.objectType,
            object.objectId
        );

        this.objectViewWidget.functionCallbacks = this.widgetToolbarCreate('ticketTypeDtoId', this.objectIdentifier.objectId);

        const defaultDto: DtoDetail = new DtoDetail();
        defaultDto['ticketTypeDtoId'] = this.objectIdentifier.objectId;

        const formControlOverwrite = new MvsFormControlOverwrite();
        formControlOverwrite.addField('ticketTypeDtoId', MvsFormFieldAccessEnum.READ);

        let params: WidgetDataParam[] = [
            WidgetDataParam.create('createDefaultDto', defaultDto),
            WidgetDataParam.create('formControlOverwrite', formControlOverwrite)];

        if (updateMode) {
            params = [];
        }

        this.objectWidget = WidgetFactory.createWidgetObject(
            `${object.objectType}.object.view.widget.create`,
            'Object',
            object.objectType,
            object.objectId,
            ...params
        );

    }

    /**
     * clear widget data when navigate
     */
    clearWidget() {
        this.isCreateMode = false;
        this.isTicketTypeUpdate = false;
        this.selectedObject = null;
        this.objectViewWidget = null;
        this.objectWidget = null;
    }

    /**
     * initialize widgets data
     */
    refreshWidgets() {
        this.refreshTicketTypeWidget();
        this.refreshTicketTypeActionWidget();
        this.refreshTicketTypeObjectRoleWidget();
        this.refreshTicketTypeObjectTypeWidget();
        this.refreshTicketTypeNotificationTypeWidget();
        this.refreshTicketTypeCompletionStatusWidget();
        this.refreshTicketTypeFieldWidget();
    }

    /**
     * return object request for widgets to show objects related to selected ticket type
     */
    getObjectRequestList(fieldName: string = 'ticketType'): ObjectRequestList {
        const filterCriteria = [FilterCriteria.create(fieldName, FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)];
        return ObjectRequestList.createBasic(true, filterCriteria, []);
    }

    /**
     * refresh ticket type widget
     */
    refreshTicketTypeWidget() {
        this.ticketTypeWidget = WidgetFactory.createWidgetEntityData(
            'tm.ticket.type.widget.basic',
            'Allgemein',
            'tm.TicketType',
            this.objectIdentifier.objectId
        );

        this.ticketTypeUpdateWidget = WidgetFactory.createWidgetObject(
            'tm.ticket.type.widget.basic.create',
            'Ticket Type',
            'tm.TicketType',
            this.objectIdentifier.objectId
        );
    }

    /**
     * refresh ticket type action widget
     */
    refreshTicketTypeActionWidget() {

        this.ticketTypeActionWidget = WidgetFactory.createWidgetSelectableEntityQl(
            'tm.TicketTypeAction.widget.basic.new',
            'Aktionen',
            'tm.TicketTypeAction',
            'Keine Daten vorhanden',
            [FilterCriteria.create('e.ticketTypeId', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)],
            [new Sorting('e.orderPriority', false)],
            WidgetDataParam.create('attributeToDisplay', 'e.name')
        );

        const fields: WidgetToolbarCreateInterface[] = [
            {fieldName: 'ticketTypeDtoId', fieldValue: this.objectIdentifier.objectId},
            {fieldName: 'actionTicketAutoCreate', fieldValue: false},
        ];

        this.ticketTypeActionWidget.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields, MvsFormFieldAccessEnum.UPDATE);

        // this.ticketTypeActionWidget.functionCallbacks = this.widgetToolbarCreate('ticketTypeDtoId', this.objectIdentifier.objectId);
    }

    /**
     * refresh ticket type action ticket mapping widget
     */
    refreshTicketTypeActionTicketMappingWidget(ticketTypeActionId: number) {
        const alias = 'tm.ticket.type.action.ticket.mapping.widget.basic.new';
        const qlQueryDto: QlQueryDto = {
            name: alias,
            type: 'view',

            start: {
                name: 'tm.TicketTypeActionTicketMapping',
                as: 'e',
                type: 'entity',
                joins: [
                    {
                        joinType: 'left',
                        type: 'entity',
                        name: 'ticketTypeAction',
                        as: 'tta',
                        fields: [
                            {
                                name: 'id'
                            },
                            {
                                name: 'name'
                            }
                        ]
                    },
                    {
                        joinType: 'left',
                        type: 'entity',
                        name: 'objectRoleSource',
                        as: 'ors',
                        fields: [
                            {
                                name: 'id'
                            },
                            {
                                name: 'name'
                            }
                        ]
                    },
                    {
                        joinType: 'left',
                        type: 'entity',
                        name: 'objectRoleTarget',
                        as: 'ort',
                        fields: [
                            {
                                name: 'id'
                            },
                            {
                                name: 'name'
                            }
                        ]
                    }
                ]
            },
            fixedFilters: [FilterCriteria.create('e.ticketTypeActionId', FilterCriteria.cOperatorEqual, ticketTypeActionId)],
            sortings: []
        };
        this.ticketTypeActionTicketMappingWidget = WidgetFactory.createWidgetTableQl(
            alias,
            'Ticket Aktion Mapping',
            qlQueryDto
        );
        this.ticketTypeActionTicketMappingWidget.functionCallbacks = this.widgetToolbarCreate('ticketTypeActionDtoId', ticketTypeActionId);
    }

    /**
     * refresh ticket action process mapping type widget
     */
    refreshTicketTypeActionProcessMappingWidget(ticketTypeActionId: number) {

        this.ticketTypeActionProcessMappingWidget = WidgetFactory.createWidgetTableEntityBasicQl('tm.ticket.type.action.process.mapping.widget.basic.new', 'Ticket Type Action Process Mapping', 'tm.TicketTypeActionProcessMapping', [FilterCriteria.create('e.ticketTypeActionId', FilterCriteria.cOperatorEqual, ticketTypeActionId)]);

        this.ticketTypeActionProcessMappingWidget.functionCallbacks = this.widgetToolbarCreate('ticketTypeActionDtoId', ticketTypeActionId);
    }

    /**
     * refresh ticket type object role widget
     */
    refreshTicketTypeObjectRoleWidget() {

        this.ticketTypeObjectRoleWidget = WidgetFactory.createWidgetSelectableEntityQl(
            'tm.TicketTypeObjectRole.widget.basic.new',
            'Objektrolle',
            'tm.TicketTypeObjectRole',
            'Keine Daten vorhanden',
            [FilterCriteria.create('e.ticketTypeId', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)],
            [],
            WidgetDataParam.create('attributeToDisplay', 'e.name')
        );
        this.ticketTypeObjectRoleWidget.functionCallbacks = this.widgetToolbarCreate('ticketTypeDtoId', this.objectIdentifier.objectId);
    }

    /**
     * refresh ticket type object type widget
     */
    refreshTicketTypeObjectTypeWidget() {
        this.ticketTypeObjectTypeWidget = WidgetFactory.createWidgetSelectableEntityQl(
            'tm.TicketTypeObjectType.widget.basic.new',
            'Ticketobjekt',
            'tm.TicketTypeObjectType',
            'Keine Daten vorhanden',
            [FilterCriteria.create('e.ticketTypeId', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)],
            [],
            WidgetDataParam.create('attributeToDisplay', 'e.name')
        );

        this.ticketTypeObjectTypeWidget.functionCallbacks = this.widgetToolbarCreate('ticketTypeDtoId', this.objectIdentifier.objectId);
    }

    /**
     * refresh ticket type notification type widget
     */
    refreshTicketTypeNotificationTypeWidget() {

        this.ticketTypeNotificationTypeWidget = WidgetFactory.createWidgetSelectableEntityQl(
            'tm.TicketTypeNotificationType.widget.basic.new',
            'Benachrichtigungen',
            'tm.TicketTypeNotificationType',
            'Keine Daten vorhanden',
            [FilterCriteria.create('e.ticketTypeId', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)],
            [],
            WidgetDataParam.create('attributeToDisplay', 'e.name')
        );
        this.ticketTypeNotificationTypeWidget.functionCallbacks = this.widgetToolbarCreate('ticketTypeDtoId', this.objectIdentifier.objectId);
    }

    /**
     * refresh ticket type completion status widget
     */
    refreshTicketTypeCompletionStatusWidget() {
        this.ticketTypeCompletionStatusWidget = WidgetFactory.createWidgetSelectableEntityQl(
            'tm.TicketTypeCompleteStatus.widget.basic.new',
            'Fertigstellungsstatus',
            'tm.TicketTypeCompleteStatus',
            'Keine Daten vorhanden',
            [FilterCriteria.create('e.ticketTypeId', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)],
            [new Sorting('e.orderPriority', false)],
            WidgetDataParam.create('attributeToDisplay', 'e.name')
        );
        this.ticketTypeCompletionStatusWidget.functionCallbacks = this.widgetToolbarCreate('ticketTypeDtoId', this.objectIdentifier.objectId);
    }

    /**
     * refresh ticket type field widget
     */
    refreshTicketTypeFieldWidget() {

        this.ticketTypeFieldWidget = WidgetFactory.createWidgetSelectableEntityQl(
            'tm.TicketTypeField.widget.basic.new',
            'Zusatzfelder',
            'tm.TicketTypeField',
            'Keine Daten vorhanden',
            [FilterCriteria.create('e.typeId', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)],
            [],
            WidgetDataParam.create('attributeToDisplay', 'e.name')
        );

        this.ticketTypeFieldWidget.functionCallbacks = this.widgetToolbarCreate('typeDtoId', this.objectIdentifier.objectId);
    }

    /**
     * handle what happens if different toolbar button on widgets are clicked
     */
    handleToolbarButtonClick(event: WidgetHelperButton, objectType: string) {

        if (event.action == 'create') {
            this.ticketTypeActionInternalType = undefined;
            this.handleObjectViewWidget(new ObjectIdentifier(objectType, 0), true);
        }

        if (event.action == 'ticketToggle') {
            this.isTicketTypeUpdate = !this.isTicketTypeUpdate;
        }

        if (event.action == 'update') {
            this.ticketTypeActionInternalType = undefined;
            this.handleObjectViewWidget(this.selectedObject, true, true);
        }
    }

    onNavigationItemChange(navigationItem: NavigationItem) {
        this.handleNavigationChange(navigationItem);
    }

    /**
     * handle navigation change
     * @param event
     */
    handleNavigationChange(event: NavigationItem) {
        this.clearWidget();
        this.refreshWidgets();

        if (event.action == 'tm.TicketTypeAction') {
            this.getTicketTypeActionsForParents();
        }
        if (event.action == 'tm.TicketTypeObjectRole') {
            this.getTicketTypeObjectRoleForParents();
        }
        if (event.action == 'tm.TicketTypeObjectType') {
            this.getTicketTypeObjectTypeForParents();
        }
        if (event.action == 'tm.TicketTypeNotificationType') {
            this.getTicketTypeNotificationTypeForParents();
        }
        if (event.action == 'tm.TicketTypeCompleteStatus') {
            this.getTicketTypeCompletionStatusForParents();
        }
        if (event.action == 'tm.TicketTypeField') {
        }

    }

    /**
     * return object request to get all objects related to parent ticket types
     */
    getObjectRequestForParents(): ObjectRequestList {
        let filterCriteria: FilterCriteria = FilterCriteria.createOrFromArray('ticketType', 'id', this.ticketTypes);

        return ObjectRequestList.createBasic(
            false,
            [filterCriteria],
            []);
    }

    /**
     * retrieve ticket type actions for parent ticket types to show in accordion
     */
    getTicketTypeActionsForParents() {
        if (this.ticketTypes.length) {
            this.ticketTypeActionService.list(this.getObjectRequestForParents()).subscribe(res => {
                this.ticketTypeActionList = res.entries;
            });
        }
    }

    /**
     * retrieve ticket type object role for parent ticket types to show in accordion
     */
    getTicketTypeObjectRoleForParents() {
        if (this.ticketTypes.length) {
            this.ticketTypeObjectRoleService.list(this.getObjectRequestForParents()).subscribe(res => {
                this.ticketTypeObjectRoleList = res.entries;
            });
        }
    }

    /**
     * retrieve ticket type object type for parent ticket types to show in accordion
     */
    getTicketTypeObjectTypeForParents() {
        if (this.ticketTypes.length) {
            this.ticketTypeObjectTypeService.list(this.getObjectRequestForParents()).subscribe(res => {
                this.ticketTypeObjectTypeList = res.entries;
            });
        }
    }

    /**
     * retrieve ticket type notification type for parent ticket types to show in accordion
     */
    getTicketTypeNotificationTypeForParents() {
        if (this.ticketTypes.length) {
            this.ticketTypeNotificationTypeService.list(this.getObjectRequestForParents()).subscribe(res => {
                this.ticketTypeNotificationTypeList = res.entries;
            });
        }
    }

    /**
     * retrieve ticket type completion status for parent ticket types to show in accordion
     */
    getTicketTypeCompletionStatusForParents() {
        if (this.ticketTypes?.length) {
            this.ticketTypeCompletionStatusService.list(this.getObjectRequestForParents()).subscribe(res => {
                this.ticketTypeCompletionList = res.entries;
            });
        }
    }

    /**
     * returns data based on ticket type id that will be shown in accordion
     * @param ticketType
     * @param list
     * @param field
     */
    getItemData(ticketType: TicketTypeDto, list: DtoDetail[], field: string) {
        return list.filter(item => ticketType.id == item[field]);
    }

    /**
     * handle row select on table in accordion
     * @param objectType
     * @param objectId
     */
    handleRowSelect(objectType: string, objectId: number) {
        this.handleObjectViewWidget(new ObjectIdentifier(objectType, objectId));
    }

    /**
     * handle row select on table in accordion for ticket type actions
     * @param ticketTypeAction
     */
    handleActionRowSelect(ticketTypeAction: TicketTypeActionDto) {
        const object: ObjectIdentifierData = new ObjectIdentifierData('tm.TicketTypeAction', ticketTypeAction.id, ticketTypeAction);
        this.handleTicketTypeAction(object)
    }

    /**
     * defaulting fields for adding new entry
     * @param fieldName
     * @param fieldValue
     */
    widgetToolbarCreate(fieldName: string, fieldValue: number) {
        return {
            onFunctionCreateNew: (): WidgetToolbarCallbackInterface => {
                const dto = new DtoDetail();
                dto[fieldName] = fieldValue;
                const formControlOverwrite = new MvsFormControlOverwrite();
                formControlOverwrite.addField(fieldName, MvsFormFieldAccessEnum.READ);

                return {
                    dto: dto,
                    formControlOverwrite: formControlOverwrite,
                };
            },
        };
    }

    handleNavigationItemsChange(): void {
        this.onNavigationItems.emit(this.navigationItems);
    }

}
